import { PlanCurrencyKind } from "shared";

export const DATE_FORMATTER_MEDIUM = new Intl.DateTimeFormat("en-US", { dateStyle: "medium" });
export function formatDate(date: Date, formatter = DATE_FORMATTER_MEDIUM) {
	return DATE_FORMATTER_MEDIUM.format(date);
}

export function formatCurrency(amount: number, currency: PlanCurrencyKind) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		minimumFractionDigits: 0,
		currency: currency.toUpperCase()
	}).format(amount);
}
